export const mailMonitorKeys = {
  all: ['mail-monitor'] as const,

  access: (companyId: number | string) => [...mailMonitorKeys.all, 'access', Number(companyId) || 0] as const,

  list: (companyId: number | string) => [...mailMonitorKeys.all, 'list', Number(companyId) || 0] as const,

  history: (companyId: number | string, mailboxId: number, days: number) =>
    [...mailMonitorKeys.all, 'history', Number(companyId) || 0, mailboxId, days] as const,

  preview: (companyId: number | string, mailboxId: number) =>
    [...mailMonitorKeys.all, 'preview', Number(companyId) || 0, mailboxId] as const,

  unread: (companyId: number | string, mailboxId: number, page: number, q: string) =>
    [...mailMonitorKeys.all, 'unread', Number(companyId) || 0, mailboxId, page, q] as const,

  message: (companyId: number | string, mailboxId: number, uid: number) =>
    [...mailMonitorKeys.all, 'message', Number(companyId) || 0, mailboxId, uid] as const,

  mine: (companyId: number | string) => [...mailMonitorKeys.all, 'mine', Number(companyId) || 0] as const,

  candidates: (companyId: number | string) =>
    [...mailMonitorKeys.all, 'candidates', Number(companyId) || 0] as const,
};
